import type { TFunction } from "i18next";
import * as yup from "yup";
import { onlyNumbersRegex } from "../static/regex";

export const getPhoneSchema = (t: TFunction) =>
  yup
    .string()
    .required(t("COMMONS.ERRORS.REQUIRED"))
    .matches(onlyNumbersRegex, t("COMMONS.ERRORS.INCORRECT_PHONE_NUMBER"))
    .test("len", t("COMMONS.ERRORS.MINIMAL_LENGTH", { minimalLength: "8" }), (val: any) => val && val.length >= 8)
    .test("len", t("COMMONS.ERRORS.MAXIMAL_LENGTH", { maximalLength: "15" }), (val: any) => val && val.length <= 15);
